import React from "react";
import type { Deal } from "@/lib/types/database/deals";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import { DealContractsTab } from "@/features/contracts/components/tabs/DealContractsTab";

export function DealContractsDisplay({ item }: TabContentProps<Deal>) {
  return <DealContractsTab dealId={item.id} dealTitle={item.title} />;
}
